import { render, staticRenderFns } from "./avatarUploader.vue?vue&type=template&id=5dbe603e"
import script from "./avatarUploader.vue?vue&type=script&lang=js"
export * from "./avatarUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports